import React from 'react';
import './Input.css';

export function Input({ label, error, hint, icon, className = '', ...props }) {
  return (
    <div className={`input-group ${className}`}>
      {label && <label className="input-label">{label}</label>}
      <div className={`input-wrap ${icon ? 'input-has-icon' : ''}`}>
        {icon && <span className="input-icon">{icon}</span>}
        <input className={`input-field ${error ? 'input-error' : ''}`} {...props} />
      </div>
      {error && <p className="input-err-msg">{error}</p>}
      {hint && !error && <p className="input-hint">{hint}</p>}
    </div>
  );
}

export function Textarea({ label, error, hint, rows = 4, className = '', ...props }) {
  return (
    <div className={`input-group ${className}`}>
      {label && <label className="input-label">{label}</label>}
      <textarea className={`input-field input-textarea ${error ? 'input-error' : ''}`} rows={rows} {...props} />
      {error && <p className="input-err-msg">{error}</p>}
      {hint && !error && <p className="input-hint">{hint}</p>}
    </div>
  );
}

export function Select({ label, error, hint, children, className = '', ...props }) {
  return (
    <div className={`input-group ${className}`}>
      {label && <label className="input-label">{label}</label>}
      <select className={`input-field input-select ${error ? 'input-error' : ''}`} {...props}>
        {children}
      </select>
      {error && <p className="input-err-msg">{error}</p>}
      {hint && !error && <p className="input-hint">{hint}</p>}
    </div>
  );
}
